import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { fetchSchools, loadSchools } from "../actions";
import configDataCountries from "../../../Config/countries.json";

const DEFAULT_FILTERS = {
    Country: "",
    CountryCustom: null,
    IsLocked: null,
    IsDeleted: false,
    Email: "",
    Phone: "",
    Name: "",
    Code: "",
    Limit: 20,
};

export const useSchoolFilters = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation("common");

    const schoolsState = useSelector((state) => state.schools);

    const [search, setSearch] = useState("");
    const [isStartSearch, setIsStartSearch] = useState(false);
    const [filters, setFilters] = useState({ ...DEFAULT_FILTERS });

    // Sorted countries for selection options
    const countries = useMemo(() => {
        return configDataCountries.countries
            .sort((a, b) => (a.label > b.label ? 1 : -1))
            .map((item) => ({
                value: item.value,
                name: item.label,
                label: (
                    <div>
                        <LazyLoadImage src={process.env.PUBLIC_URL + item.icon} /> {item.label}
                    </div>
                ),
                icon: item.icon,
            }));
    }, []);

    // Perform Sync search
    const handleSearchSync = useCallback(
        (customFilters) => {
            const activeFilters = customFilters || filters;
            setIsStartSearch(true);
            dispatch(loadSchools());

            setTimeout(() => {
                dispatch(
                    fetchSchools({
                        Country: activeFilters.Country || "",
                        CountryCustom: activeFilters.CountryCustom,
                        IsLocked: activeFilters.IsLocked,
                        IsDeleted: activeFilters.IsDeleted,
                        Email: activeFilters.Email,
                        Phone: activeFilters.Phone,
                        Limit: activeFilters.Limit,
                        Name: activeFilters.Name,
                        Code: activeFilters.Code,
                    })
                );
            }, 500);
        },
        [filters, dispatch]
    );

    // Reset filters
    const handleClearFilters = useCallback(() => {
        const resetFilters = { ...DEFAULT_FILTERS };
        setFilters(resetFilters);
        handleSearchSync(resetFilters);
    }, [handleSearchSync]);

    // Initial load sync
    useEffect(() => {
        handleSearchSync();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Derived states
    const schoolsList = schoolsState?.schools || [];
    const isSchoolsLoaded = schoolsState?.isLoaded || false;
    const toRemoveList = schoolsState?.toRemove || [];

    return {
        search,
        setSearch,
        filters,
        setFilters,
        isStartSearch,
        countries,
        handleSearchSync,
        handleClearFilters,
        schoolsList,
        isSchoolsLoaded,
        toRemoveList,
        t,
    };
};

export default useSchoolFilters;
